<template>
	<div style="margin-left:50px">
	  <div class="subTop1">
	    <em>Hot Topics</em>
	    <span>热点话题</span>
	    <!--箭头-->
	    <div class="arrow">
	      <i class="arrow-left" :class="showpage<1?'arr-disable':''" @click="pre()"></i>
	      <i class="arrow-right" :class="showpage>=(maxpage-1)?'arr-disable':''" @click="next()"></i>
			</div>
	  </div>
	  <div class="slider">
	    <ul>
	        <li>
	          <div class="imgWap">
							<div class="imgItem" v-for="(item,index) in huatiList" v-if="index>=(showpage*4)&&index<((showpage+1)*4)">
							  <a class="smallImg" @click="trackClick('/theme/'+item.title+'/1?col=shuzi',item.title)">
							    <span>{{item.title}}</span>
							    <img :src="item.image" class="jp">
							    <div class="bg_blue"></div>
							    <img src="images/arw_white.png" class="arw"/>
							  </a>
							</div>
							<!-- <div class="imgItem">
							  <a class="smallImg" @click="trackClick('/theme/ChatGPT/1?col=shuzi','ChatGPT')">
							    <span>ChatGPT</span>
							    <img src="images/sPic04.png" class="jp">
							    <div class="bg_blue"></div>
							    <img src="images/arw_white.png" class="arw"/>
							  </a>
							</div>
							<div class="imgItem">
							  <a class="smallImg" @click="trackClick('/theme/区块链/1?col=shuzi','区块链')">
							    <span>区块链</span>
							    <img src="images/sPic01.png" class="jp">
							    <div class="bg_blue"></div>
							    <img src="images/arw_white.png" class="arw"/>
							  </a>                      
							</div>
							<div class="imgItem">
							  <a class="smallImg" @click="trackClick('/theme/元宇宙/1?col=shuzi','元宇宙')">
							    <span>元宇宙</span>
							    <img src="images/sPic02.png" class="jp">
							    <div class="bg_blue"></div>
							    <img src="images/arw_white.png" class="arw"/>
							  </a>
							</div>
							<div class="imgItem">
							  <a class="smallImg" @click="trackClick('/theme/智能网联汽车/1?col=shuzi','智能网联汽车')">
							    <span>智能网联汽车</span>
							    <img src="images/sPic03.png" class="jp">
							    <div class="bg_blue"></div>
							    <img src="images/arw_white.png" class="arw"/>
							  </a>
							</div> -->
							
							
							
							<!-- <div v-for="(item,index) in zhuantiList.data" v-if="index>=(showpage*4)&&index<((showpage+1)*4)" class="imgItem">
							  <a @click="$router.push({ name: zhuantiurlList[item.columnid]?zhuantiurlList[item.columnid]:'' })" class="smallImg">
							    <span>{{item.columnname}}</span>
							    <img :src="'/images/'+zhuantiImageList[item.columnid]" class="jp">
							    <div class="bg_blue"></div>
									<img src="images/arw_white.png" class="arw"/> -->
							    <!-- <div class="bigImg">
							      <em>{{item.columnname}}</em>
							      <img :src="'/images/'+zhuantiImageList[item.columnid]">
							      <div class="bg_green"></div>
							    </div> -->
							  <!-- </a>                      
							</div> -->
	            <!-- <div class="imgItem">
	              <a href="##" class="smallImg">
	                <span>工业互联网</span>
	                <img src="images/sPic01.png">
	                <div class="bg_blue"></div>
	                <div class="bigImg">
	                  <em>工业互联网</em>
	                  <img src="images/sPic01.png">
	                  <div class="bg_green"></div>
	                </div>
	              </a>                      
	            </div>
	            <div class="imgItem">
	              <a href="##" class="smallImg">
	                <span>数字基础设施</span>
	                <img src="images/sPic02.png">
	                <div class="bg_blue"></div>
	                <div class="bigImg">
	                  <em>数字基础设施</em>
	                  <img src="images/sPic02.png">
	                  <div class="bg_green"></div>
	                </div>
	              </a>
	            </div>
	            <div class="imgItem">
	              <a href="##" class="smallImg">
	                <span>数字金融</span>
	                <img src="images/sPic03.png">
	                <div class="bg_blue"></div>
	                <div class="bigImg">
	                  <em>数字金融</em>
	                  <img src="images/sPic03.png">
	                  <div class="bg_green"></div>
	                </div>
	              </a>
	            </div>
	            <div class="imgItem">
	              <a href="##" class="smallImg">
	                <span>数字贸易</span>
	                <img src="images/sPic04.png">
	                <div class="bg_blue"></div>
	                <div class="bigImg">
	                  <em>数字贸易</em>
	                  <img src="images/sPic04.png">
	                  <div class="bg_green"></div>
	                </div>
	              </a>
	            </div> -->
	          </div>
	        </li>
	    </ul>            
	    <div class="box">
	        <ul>
	            <li class="show"></li>
	            <li></li>
	            <li></li>
	            <li></li>
	            <li></li>
	        </ul>
	    </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloadingimg:true,
				isloadingtuijian:true,
				zhuantiList: [],
				showpage:0,
				maxpage:2,
				highlightId:'846ba54f16b149abb138ce025db7158e',
				bannerdata:'',
				bannersrc:'',
				tuijianList:[],
				huatiList:[
					{
						title:'大模型',
						image:'images/sPic04.png'
					},
					{
						title:'区块链',
						image:'images/sPic01.png'
					},
					{
						title:'元宇宙',
						image:'images/sPic02.png'
					},
					{
						title:'自动驾驶',
						image:'images/sPic03.png'
					},
					{
						title:'半导体',
						image:'images/sPic09.png'
					},
					{
						title:'平台经济',
						image:'images/sPic10.png'
					},
					{
						title:'个人信息安全',
						image:'images/sPic11.png'
					},
					{
						title:'数字钱包',
						image:'images/sPic12.png'
					},
				],
				zhuantiurlList:{
					'846ba54f16b149abb138ce025db7158e':'ztshuzijichusheshi',
					'cb73c07d93634bb9b24cd49bf7987eb6':'ztgongyehulianwang',
					'f49e9dcf5b244d6491d65744ebe18647':'ztzhihuiwuliu',
					'96eb4f0785c142bb9f95055b725df7cb':'ztshuzijinrong',
					'bbfc2d5c187c4935b1df8b50b793e829':'ztshuzizhengwu',
					'1d1b5e0a72f14ee6a58e258d26c637ea':'ztshuzizhili',
					'c196b0a500ae44aeab1417596ab19356':'ztshuzimaoyi',
					'b24449014b594c47935c7d2caf594647':'ztshuzixiangcun',
				},
				zhuantiImageList:{
					'846ba54f16b149abb138ce025db7158e':'small_szjcss.png',
					'cb73c07d93634bb9b24cd49bf7987eb6':'small_gyhlw.png',
					'f49e9dcf5b244d6491d65744ebe18647':'small_zhjt.png',
					'96eb4f0785c142bb9f95055b725df7cb':'small_szjr.png',
					'bbfc2d5c187c4935b1df8b50b793e829':'small_szzf.png',
					'1d1b5e0a72f14ee6a58e258d26c637ea':'small_szzl.png',
					'c196b0a500ae44aeab1417596ab19356':'small_szmy.png',
					'b24449014b594c47935c7d2caf594647':'small_szxc.png',
				}
			}
		},
		created: function() {
			// this.zhuantifnc();
		},
		mounted() {
			// this.tuijianfnc('聚焦二十大');
			// this.bannerfnc('56ce6ee282074164803964bf3bace0d2')
		},
		computed: {
	
		},
		methods: {
			trackClick:function(url,type){
				this.$track([
					['pagetype','首页-热点话题-'+type+'-点击'],
				]);
				this.$router.push(url);
			},
			// zhuantiChange:function(id,name){
			// 	if(this.highlightId!=id){
			// 		this.highlightId=id;
			// 		this.tuijianfnc(name);
			// 		this.bannerfnc(id);
			// 	}
			// },
			// tuijianfnc: function(ztname) {
			// 	this.isloadingtuijian=true;
			// 	let _this = this;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'getXZWSubjectHotArticles',
			// 			responseType: 'json',
			// 			params: {
			// 				cName:ztname
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.tuijianList=response.data.data.data;
			// 			_this.isloadingtuijian=false;
			// 		})
			// 		.catch(function(error) {
			// 			console.log(error);
			// 		});
			// },
			// bannerfnc: function(id) {
			// 	this.isloadingimg=true;
			// 	this.bannersrc=this.zhuantiurlList[id]?this.zhuantiurlList[id]:'';
			// 	let _this = this;
			// 	this.$http({
			// 			method: 'get',
			// 			url: 'selecImgtBycolumnID',
			// 			responseType: 'json',
			// 			params: {
			// 				columnID: this.zhuantiImageList[id],
			// 			},
			// 		})
			// 		.then(function(response) {
			// 			_this.bannerdata=response.data.data.data.images[_this.zhuantiImageList[id]];
			// 			_this.isloadingimg=false;
			// 		})
			// 		.catch(function(error) {
			// 			console.log(error);
			// 		});
			// },
			zhuantifnc: function() {
				let _this = this;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'selectByparentID',
						responseType: 'json',
						params: {
							parentID: '3d90e549b57440c499ec819226dbe648',
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						var temparr=response.data.data.data;
						// for(var i=0;i<temparr.data.length;i++){
						// 	if(temparr.data[i].columnnamethird=='专精特新'){
						// 		temparr.data.splice(i,1);
						// 		break;
						// 	}
						// }
						_this.zhuantiList = temparr;
						_this.maxpage=Math.ceil(_this.zhuantiList.data.length/4);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			pre:function(){
				if(this.showpage>0){
					this.showpage--;
				}
				else{
					this.showpage=this.maxpage-1;
				}
			},
			next:function(){
				if(this.showpage<(this.maxpage-1)){
					this.showpage++;
				}
				else{
					this.showpage=0;
				}
			},
		}
	}
</script>

<style>
</style>
